<template>
  <div class="bg-gray-50 py-6 pb-24 space-y-6" dir="rtl">
    <div class="max-w-2xl mx-auto px-4 space-y-6">
    
    <!-- Date Range -->
    <div class="bg-white rounded-xl p-5 border border-gray-200">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">از تاریخ</label>
          <date-picker v-model="start_date" />
        </div>
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">تا تاریخ</label>
          <date-picker v-model="end_date" />
        </div>
        </div>
        </div>

    <!-- Empty State -->
    <div v-if="request_items.length === 0" class="flex flex-col items-center justify-center py-20">
      <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <p class="text-gray-500 text-sm">نتیجه‌ای یافت نشد</p>
    </div>

    <!-- Leave Requests List -->
    <div v-else class="space-y-3">
      <div 
        v-for="item in request_items"
        :key="item.Id"
        :class="[
          'bg-white rounded-xl border p-5 transition-all duration-200',
          card_style(item) === 'blue' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:shadow-md'
        ]"
      >
        <!-- Header -->
        <div class="flex items-center gap-3 mb-4">
          <div class="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0">
            <svg class="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div class="w-full">
            <p class="text-xs text-gray-500 mb-1">شماره درخواست</p>
            <h3 class="text-base font-bold text-gray-900">{{ item.LeaveCode }}</h3>
          </div>
          <div v-if="card_style(item) === 'blue'" class="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
              </div>

        <!-- Request Info -->
        <div class="grid grid-cols-2 gap-3 mb-3">
          <div class="p-3 bg-gray-50 rounded-lg">
            <p class="text-xs text-gray-600 mb-1">نوع درخواست</p>
            <p class="text-sm font-bold text-gray-900">{{ morakhasi_type_list.filter(x=>x.value==item.LeaveType)[0].label }}</p>
          </div>
          <div class="p-3 bg-gray-50 rounded-lg">
            <p class="text-xs text-gray-600 mb-1">جانشین</p>
            <p class="text-sm font-bold text-gray-900">{{ item.SuccessorName }}</p>
          </div>
              </div>

        <div class="grid grid-cols-2 gap-3 mb-3">
          <div class="p-3 bg-gray-50 rounded-lg">
            <p class="text-xs text-gray-600 mb-1">از تاریخ</p>
            <p class="text-sm font-bold text-gray-900">{{ get_date_time(item.FromDate) }}</p>
          </div>
          <div class="p-3 bg-gray-50 rounded-lg">
            <p class="text-xs text-gray-600 mb-1">تا تاریخ</p>
            <p class="text-sm font-bold text-gray-900">{{ get_date_time(item.ToDate) }}</p>
              </div>
              </div>

        <!-- Description -->
        <div v-if="item.LeaveDesc" class="p-3 bg-gray-50 rounded-lg mb-3">
          <p class="text-xs text-gray-600 mb-1">توضیحات</p>
          <p class="text-sm text-gray-900">{{ item.LeaveDesc }}</p>
              </div>

        <!-- Status Badge -->
        <div class="flex items-center justify-center">
                <div
v-if="item.FirstAccepted==''"
            class="px-4 py-2 bg-yellow-100 text-yellow-800 rounded-full text-sm font-bold"
          >
            در انتظار تایید
          </div>
                <div
v-if="item.FirstAccepted!='' && item.SecondAccepted==''"
            class="px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-bold"
          >
            در انتظار تاییدیه دوم
          </div>
                <div
v-if="item.FirstAccepted!='' && item.SecondAccepted!=''"
            class="px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-bold"
          >
            تایید شده
              </div>
            </div>

      </div>
          </div>

      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_records') }}</div>
      </infinite-loading>

    <!-- Add Request Button -->
    <button 
      @click="go_to_add_morakhasi()"
      class="w-full bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
    >
      درخواست مرخصی
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
    </button>

    <!-- Change Status Dialog -->
    <div v-if="dialog_model" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-end justify-center p-4 pb-8">
      <div class="bg-white rounded-t-2xl shadow-xl w-full max-w-md max-h-90vh overflow-hidden flex flex-col">
        <!-- Header -->
        <div class="px-6 py-4 bg-gradient-to-r from-indigo-600 to-indigo-700 flex items-center justify-between flex-shrink-0">
          <h2 class="text-lg font-bold text-white">{{ $t('add_status') }}</h2>
          <button 
            @click="dialog_model = false"
            class="w-8 h-8 rounded-lg bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 flex items-center justify-center transition-colors"
          >
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <!-- Body -->
        <div class="px-6 py-6 overflow-y-auto flex-1 space-y-4">
          <!-- Status Select -->
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('NewStatusChangeStatus') }}</label>
            <div class="relative">
              <select 
                v-model="selected_status_for_change"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 appearance-none bg-white"
              >
                <option 
                  v-for="status in status_list"
                  :key="status.value"
                  :value="status.value"
                >
                  {{ status.label }}
                </option>
              </select>
              <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Summary Textarea -->
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('summary') }}</label>
            <textarea
                  v-model="status_summary"
              rows="3"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
              placeholder="توضیحات را وارد کنید..."
            ></textarea>
          </div>

          <!-- Signature Pad -->
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('signature_place') }}</label>
            <div class="border border-gray-300 rounded-lg p-2 bg-white">
              <VueSignaturePad ref="signaturePad" :options="signature_options" />
            </div>
            <button 
              @click="undo"
              class="w-full mt-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors text-sm font-medium"
            >
              پاک کردن امضا
            </button>
          </div>
        </div>
        
        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex gap-3 flex-shrink-0">
          <button 
              @click="dialog_model = false"
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-all duration-200"
          >
            {{ $t('cancel') }}
          </button>
          <button 
              v-if="selected_status_for_change != 0"
              @click="go_to_finalize(0)"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white font-medium rounded-lg transition-all duration-200"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
  </div>

    </div>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  import VueSignaturePad from 'vue-signature-pad'
  Vue.use(VueSignaturePad)

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  import moment from 'moment-jalaali'

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        start_date:'',
        end_date:'',
        morakhasi_type_list:[
          {label:'انتخاب کنید',value:0},
          {label:'ساعتی ',value:1},
          {label:'استحقاقی ',value:2},
          {label:'استعلاجی',value:3},
          {label:'دون حقوق',value:4}],
        signature_options: {
          dotSize: (0.5 + 2.5) / 2,
          minWidth: 0.5,
          maxWidth: 2.5,
          throttle: 16,
          minDistance: 5,
          backgroundColor: 'rgb(255,255,255)',
          penColor: 'black',
          velocityFilterWeight: 0.7,
          onBegin: () => {
          },
          onEnd: () => {
          }
        },
        dialog_model: false,
        status_summary: '',
        active_tab: 0,
        selected_status_for_change: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        status_list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        request_statuses: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      },
      start_date: function () {
        this.get_pre_requests(0)
      },
      end_date: function () {
        this.get_pre_requests(0)
      },

    },
    mounted() {
      this.start_date = moment().utc().add(-7, 'day').format('jYYYY/jMM/jDD');
      this.end_date = moment().utc().format('jYYYY/jMM/jDD');

      this.get_device_status();
    },

    methods: {
      get_date_time(date){
       return moment(date).format('jYYYY/jM/jD HH:mm');
      },
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      go_to_add_morakhasi(){
        this.$router.push({name:'AddMorakhasi'})
      },
      get_pre_requests($state) {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          PersonId: 0,
          fDate:this.start_date,
          tDate:this.end_date,
          // Count: this.page,
        }
        // GetLeaveDataRpt => UserId PersonId fDate tDate
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetLeaveDataRpt', send_data, {})
          .then(response => {
            self.request_items = []
            if (response.data.error == 0) {
                self.request_items=(JSON.parse(response.data.items))
              console.log("my status", self.request_items)

            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item) {
        if (this.disable_click) {
          return;
        }
        console.log("go to detail worked", item)
        // if (item.related_products != null) {
          this.selected_product_info = item;
          this.product_info_dialog = true;
        // }

      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize(index_item) {
       var self = this;
        var array = this.request_items.filter(x => x.selected == true);
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
console.log(array)
        const send_data = {
          GRequestProductId: array[index_item].GoodsRequestProductId,
          StatusId: this.selected_status_for_change,
          Summary: this.status_summary,
          UserId: user_id,
        };

        this.axios.post('/AddGoodsRequestStatus', send_data, {})
          .then(response => {
if(array.length-1 == index_item){
  bus.$emit('show_toast', [2000, response.data.msg])
  self.dialog_model = false
  self.get_pre_requests()
  self.enable_finalize = false;

}else{
  self.go_to_finalize(index_item+1)
}
          }).catch(e => {
          this.errors.push(e)
        })

        },
      get_device_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
            self.status_list = [{label: self.$t('select_status'), value: 0},
              {label: self.$t('returned'), value: self.request_statuses[9]},
              {label: self.$t('sent_to_technician'), value: self.request_statuses[10]},
              {label: self.$t('sent_to_warehouse'), value: self.request_statuses[13]},
              {label:"تحویل تعمیرگاه مربوطه شد", value: self.request_statuses[14]}
            ]

            self.get_pre_requests();

          }).catch(e => {
          this.errors.push(e)
        })
      },
      undo () {
        this.$refs.signaturePad.clearSignature()
      },
      save () {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/png')
        // var data_image = this.$refs.signaturePad.getPropImagesAndCacheImages()
        // console.log(this.$refs.signaturePad.getPropImagesAndCacheImages());
        // console.log(data);
        // Usage example:
        var file = this.dataURLtoFile(data, 'signature.png')
        console.log(file)
        // this.$refs.signaturePad.fromData(data)
        this.upload_image(file)
      },
      upload_image (image_data) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', this.req_type)
        form_data.append('Picture', image_data)

        //
        // const send_data = {
        //   "UserId": user_id,
        // };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            self.send_signature(response.data.ArchiveId, response.data.ImageName)
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type:mime })
      },

      send_signature (archive_id, file_name) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()

        var sign_type = 0

        if (this.req_type == 4) {
          sign_type = 1
        }
        if (this.req_type == 5) {
          sign_type = 2
        }

        const send_data = {
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
          ImageName: file_name,
          ArchiveId: archive_id,
          SigType: sign_type,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/SetRequestSignature', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // self.$router.push({name: 'attachment', params: {'rec_id': self.$route.params.rec_id}})
              if (self.req_type == 4 || self.req_type == 5) {
                self.$router.push({ name: 'requestAddress', params: { rec_id: self.$route.params.rec_id } })
              }
            } else {
              bus.$emit('show_toast', [1500, self.$t('errorUploadSign')])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
